const PricingFeaturesDataList = [
  { title: "Notification of new features & bug fixes", metaPlus: true, metaPremium: true, metaBusiness: true },
  { title: "DrawSVG", metaPlus: true, metaPremium: true, metaBusiness: true },
  { title: "Physics2D", metaPlus: true, metaPremium: true, metaBusiness: true },
  { title: "PhysicsProps", metaPlus: true, metaPremium: true, metaBusiness: true },
  { title: "ScrambleText", metaPlus: true, metaPremium: true, metaBusiness: true },
  { title: "CustomBounce", metaPlus: true, metaPremium: true, metaBusiness: true },
  { title: "CustomWiggle", metaPlus: true, metaPremium: true, metaBusiness: true },
  { title: "ScrollSmoother", metaPlus: false, metaPremium: true, metaBusiness: true },
  { title: "MorphSVG", metaPlus: false, metaPremium: true, metaBusiness: true },
  { title: "Inertia", metaPlus: false, metaPremium: true, metaBusiness: true },
  { title: "SplitText", metaPlus: false, metaPremium: true, metaBusiness: true },
  { title: "MotionPathHelper", metaPlus: false, metaPremium: true, metaBusiness: true },
  { title: "GSDevTools", metaPlus: false, metaPremium: true, metaBusiness: true },
  { title: "Commercial License", metaPlus: false, metaPremium: false, metaBusiness: true },
  { title: "Multi-Developer Memberships Available", metaPlus: false, metaPremium: false, metaBusiness: true },
];

export default PricingFeaturesDataList